<template>
  <div className="app-container">
    <div class="header" style="height: 30px;background-color: white">
      <div class="header-div">当前点击数：</div>
      <div class="header-div">
        <el-input size="mini" v-model="this.listQuery.limit" placeholder="请输入获取点击坐标个数"/>
      </div>
      <div class="header-div">
        <button id="btn" @click="loadData">搜索</button>
      </div>
      <div class="header-div">
        <button id="btn" @click="downExcelCSV('webCoordDefine/heatmap/csv','热力图坐标',listQuery)">导出</button>
      </div>
      <div class="header-error">
        <sapn>点击坐标值超出广告位范围：{{ this.errorOutOfRange }}</sapn>
        <sapn style="margin-left: 20px" >当前广告位：{{ this.listQuery.slotName }}</sapn>
      </div>
    </div>
    <div id="heatmap"/>
  </div>
</template>

<script>
// 引入heatmap.js
import Heatmap from 'heatmap.js'
import { downExcelMixin } from '@/mixins/downExcel'
import { getHeatMap } from '@/api/select'

export default {
  name: 'Heatmap',
  components: {},
  mixins: [downExcelMixin],
  data () {
    return {
      title: 0,
      width: 3000,
      height: 3000,
      points: [],
      minWidth: undefined,
      minHeight: undefined,
      xList: [],
      yList: [],
      xyList: [],
      xNum: undefined,
      yNum: undefined,
      xNumConst: undefined,
      yNumConst: undefined,
      errorOutOfRange: 0,
      slogName: '',
      listQuery: {
        slotName: this.$route.query.slotName,
        slotId: this.$route.query.slotId,
        dspSlotId: this.$route.query.dspSlotId,
        date: this.$route.query.date,
        limit: 10000
      }
    }
  },
  mounted () {
    // this.paintingGrid()
    this.loadData()
  },
  methods: {
    paintingGrid () {
      this.minWidth = this.width / 300
      this.minHeight = this.height / 300

      // 遍历出所有的横坐标
      this.xNum = this.minWidth / 2
      this.xNumConst = this.minWidth / 2
      for (let i = 0; i < 300; i++) {
        this.xList.push(this.xNum)
        this.xNum += this.minWidth
      }
      // 遍历出所有的纵坐标
      this.yNum = this.minHeight / 2
      this.yNumConst = this.minHeight / 2
      for (let j = 0; j < 300; j++) {
        this.yList.push(this.yNum)
        this.yNum += this.minHeight
      }
      // 遍历出所有的小格子坐标
      const xyList = []
      for (let a = 0; a < this.xList.length; a++) {
        for (let b = 0; b < this.yList.length; b++) {
          var xyItem = {
            x: this.xList[a],
            y: this.yList[b]
          }
          xyList.push(xyItem)
        }
      }
      this.xyList = Object.freeze(xyList)
    },
    createHotMap (max, points) {
      document.querySelector('#heatmap').innerHTML = ''
      // 热力图生成
      const heatmapInstance = Heatmap.create({
        container: document.querySelector('#heatmap'),
        radius: 10
      })
      const data = {
        max: max,
        data: points
      }
      heatmapInstance.setData(data)
    },
    loadData () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      getHeatMap(this.listQuery).then(res => {
        if (res.code === 200) {
          const clickPointMap = new Map()
          res.data.data.forEach((itts) => {
            const key = itts.x + '_' + itts.y
            const item = clickPointMap.get(key)
            if (item !== undefined) {
              item.index = item.index + 1
              clickPointMap.set(key, item)
            } else {
              clickPointMap.set(key, {
                x: itts.x,
                y: itts.y,
                index: 1
              })
            }
          })
          this.listQuery.limit = res.data.data.length
          this.errorOutOfRange = res.data.errorOutOfRange
          this.clickBtn(clickPointMap,res.data.data)
        }
      }).finally(() => {
        loading.close()
      })
    },
    isNewXY (pageX, pageY) {
      let clickXY = {}
      const { xNumConst, yNumConst } = this
      const xyList = this.xyList
      for (let i = 0, len = xyList.length; i < len; i++) {
        const item = xyList[i]
        const x1 = item.x - xNumConst
        const y1 = item.y - yNumConst
        const x2 = item.x + xNumConst
        const y2 = item.y + yNumConst
        if ((pageX >= x1 && pageX <= x2) && (pageY >= y1 && pageY <= y2)) {
          clickXY = {
            x: item.x,
            y: item.y
          }
          break
        }
      }
      return clickXY
    },
    clickBtn (clickPointMap,data) {
      let sum = 0
      let count = 0
      let weights = this.listQuery.limit / 10000
      const tempData = Array.from(clickPointMap.values())
      tempData.forEach((item) => {
        if (item.index !== 1) {
          sum = sum + item.index
          count++
        }
        delete item.index
        item.x = Math.floor(item.x)
        item.y = Math.floor(item.y)
      })
      weights = weights <= 0.2 ? weights * 5 : weights
      sum = sum === 0 ? 1 : sum
      count = count === 0 ? 1 : count
      let avg = sum / count
      avg = avg > 20 ? 2 : avg
      this.createHotMap(avg + weights, data)
    }
  }
}
</script>

<style>
body {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: black;
}

#heatmap {
  width: 1280px;
  height: 2700px;
}

.header-div {
  float: left;
}

</style>
